import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { Modal } from 'Components/Modal';
import { Label } from 'Components/Label';
import { TextBox } from 'Components/TextBox';
import { PurpleButton } from 'Components/Button';

import { ValidateBackGround } from 'Components/Validation';

import formClasses from 'Themes/form/form.module.css';
import classes from './editEquipmentModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;
  canEdit: boolean;
  formErrors: any;
  // equipment variables
  equipmentName: string;
  // modal functions
  modalCloseClick: (e: any) => void;
  onEditButtonClick: (e: any) => void;
  // equipment functions
  onChangeEquipmentName: (e: any) => void;
}

function EditEquipmentModal({
  isOpen,
  canEdit,
  formErrors,
  equipmentName,
  modalCloseClick,
  onEditButtonClick,
  onChangeEquipmentName,
}: Props) {
  return (
    <Modal
      id="edit-equipment-inventory-modal"
      classes={classes}
      title="Edit Equipment"
      isOpen={isOpen}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={modalCloseClick}
    >
      <form
        className={`requires-validation g-3 ${formClasses.formBase} ${classes.container}`}
        noValidate
        action="#"
        onSubmit={onEditButtonClick}
      >
        <ValidateBackGround isValid={!formErrors?.name?.length}>
          <Label ariaLabel="Equipment Name" className={formClasses.label} htmlFor="equipmentName">
            Equipment Name
          </Label>
          <TextBox
            value={equipmentName}
            name="equipmentName"
            type="text"
            className={`mb-0 pb-0 ${formClasses.validateField} ${
              formErrors?.name?.length ? formClasses.invalidField : formClasses.validField
            } ${formErrors?.name?.length ? 'is-invalid' : ''}`}
            required
            placeholder=""
            ariaLabel="Please enter the equipment name"
            onChange={onChangeEquipmentName}
            autoComplete="off"
          />
          <div
            className={`${formClasses.invalidFieldFeedback} invalid-feedback ${
              formErrors?.name?.length ? 'd-block' : ''
            }`}
          >
            {formErrors?.name?.[0]}
          </div>
        </ValidateBackGround>
        <br />
        <div className={`modal-footer ${classes.modalFooter}`}>
          <PurpleButton onClick={modalCloseClick} className={classes.cancelButton}>
            Cancel
          </PurpleButton>
          <PurpleButton onClick={onEditButtonClick} disabled={!canEdit} className={classes.editButton}>
            Edit
          </PurpleButton>
        </div>
      </form>
    </Modal>
  );
}

const EditEquipmentModalMemo = memo(EditEquipmentModal, areEqual);

export { EditEquipmentModalMemo as EditEquipmentModal };
